// extracted by mini-css-extract-plugin
export var text = "_84-0";